<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Problema/condição avaliado neste atendimento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.geral.ciap"
                        :request-query-string-params="{
                            cid_id: model.cid ? model.cid.id : null,
                            sexo_id: data.model.cidadao.sexoId,
                            show_all: true,
                            not_in: [
                                enums.ciap.MEDICINA_FISICA_REABILITACAO,
                                enums.ciap.TUBERCULOSE,
                                enums.ciap.DENGUE_E_OUTRAS_DOENCAS_VIRAIS_NE,
                                enums.ciap.HANSENIASE_E_OUTRAS_DOENCAS_INFECCIOSAS_NE,
                                enums.ciap.FATOR_DE_RISCO_PARA_DOENCA_CARDIOVASCULAR,
                                enums.ciap.HIPERTENSAO_SEM_COMPLICACOES,
                                enums.ciap.ABUSO_AGUDO_DE_ALCOOL,
                                enums.ciap.ABUSO_DO_TABACO,
                                enums.ciap.ABUSO_DE_DROGAS,
                                enums.ciap.DOENCA_PULMONAR_OBSTRUTIVA_CRONICA,
                                enums.ciap.ASMA,
                                enums.ciap.OBESIDADE,
                                enums.ciap.DIABETES_NAO_INSULINO_DEPENDENTE,
                                enums.ciap.DEFICIENCIA_VITAMINICA_NUTRICIONAL,
                                enums.ciap.SINAIS_SINTOMAS_POS_PARTO,
                                enums.ciap.CONSULTA_COM_PROFISSIONAL_DE_APS
                            ],
                        }"
                        :search-fields="fields.ciap"
                        :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                        :results-limit= "20"
                        :validations="validations.ciap"
                        label="CIAP 2"
                        v-model="model.ciap"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.cid"
                        :request-query-string-params="{
                            ciap_id: model.ciap ? model.ciap.id : null,
                            sexo: data.model.cidadao.sexoId,
                        }"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :results-limit= "20"
                        :validations="validations.cid"
                        label="CID 10"
                        v-model="model.cid"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import ciap from '@/enums/geral/ciap'
import problemaCondicaoSituacao from '@/enums/ambulatorio/problemaCondicaoSituacao'

// Mixins.
import { error, object, repository} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {

        validations() {
            return {
                ciap: {required: !this.model.cid},
                cid: {required: !this.model.ciap},
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        enums: {ciap, problemaCondicaoSituacao},
        fields: {
            ciap: [
                {key: 'geral_ciap.codigo', searchable: true},
                {key: 'geral_ciap.descricao', searchable: true},
            ],
            cid: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
        },
        item: null,
        model: {
            ciap: null,
            cid: null,
        },
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                ciap: this.item.ciap,
                cid: this.item.cid,
            })
        },
        store(model) {
            const preparedModel = this.prepareData(model)

            this.data.model.problemasCondicoes.push(preparedModel)
        },
        update(model) {
            Object.assign(this.item, this.prepareData(model))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const problemasCondicoes = this.item?.id
                        ? this.data.model.problemasCondicoes.filter(item => item.id !== this.item.id)
                        : this.data.model.problemasCondicoes

                    const existe = problemasCondicoes.find(item => item.ciap && item.ciap.id && item.ciap.id === this.model.ciap?.id
                        || item.cid && item.cid.id && item.cid.id === this.model.cid?.id)

                    if (existe) {
                        this.showAlert(`O CIAP 2 ou o CID 10 já existem neste atendimento.`, 'Atenção')
                        return false
                    }

                    if (this.item) {
                        this.update(this.model)
                    } else {
                        this.store(this.model)
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        prepareData(model) {

            return {
                ciap: model.ciap ? {
                    id: model.ciap.id,
                    codigo: model.ciap.codigo,
                    descricao: model.ciap.descricao,
                } : null,
                cid: model.cid ? {
                    id: model.cid.id,
                    codigo: model.cid.codigo,
                    nome: model.cid.nome,
                } : null,
            }
        },
        resetForm() {
            this.item = null
            this.model.ciap = null
            this.model.cid = null
        },
    },
    mixins: [error, object, repository],
    props: {
        data: {required: true, type: Object},
    },
}
</script>